import headerBar from './HeaderBar/HeaderBar';
import sideBar from './SideBar/SideBar';

export const HeaderBar = headerBar;
export const SideBar = sideBar;
